export default __webpack_public_path__ + "60a2bfd80ad5a80fb8985c797353c702.png";